import Image from "next/image";
import { useWebTranslation } from "translations";
import { Icon } from "ui-kit";
import Colors from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import styles from "./Title.module.css";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";

export const Title = ({
  name,
  imageUrl,
}: {
  name?: string | null;
  imageUrl?: string;
}) => {
  const { t } = useWebTranslation();
  const animals = useAllValidAnimals();

  return (
    <div>
      <div className={styles.badge}>
        {imageUrl ? (
          <>
            <Image src={imageUrl} alt="" width={70} height={70} />
            <Icon
              name="checkmark-badge-fill"
              size="M"
              color={Colors.green300}
              className={styles.badgeIcon}
            />
          </>
        ) : null}
      </div>
      <Typography variant="h1" style={{ textAlign: "center" }}>
        {animals.length > 1
          ? t("signup.thank_you.title_multipet")
          : t("signup.thank_you.title", { name: name ?? "" })}
      </Typography>
    </div>
  );
};
